export function ConfirmDialog({
  title,
  message,
  confirmLabel = "実行する",
  cancelLabel = "キャンセル",
  danger = false,
  busy = false,
  onConfirm,
  onCancel,
}: {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div className="modal-panel" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 400 }}>
        <div className="modal-header">
          <h2 className="section-title" style={{ margin: 0 }}>
            {title}
          </h2>
        </div>
        <p style={{ color: "var(--color-text-muted)", marginBottom: 20 }}>{message}</p>
        <div className="form-row">
          <button className="btn btn-secondary btn-block" onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </button>
          <button
            className={`btn btn-block ${danger ? "btn-danger" : "btn-primary"}`}
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? "処理中..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
